// extracted by mini-css-extract-plugin
export default {"wrapper":"az-z","viewport":"bz-z","container":"cz-z","slide":"dz-z"};